import React, { Component } from 'react';
import { Button, Tabs, Tab, Spinner } from 'react-bootstrap';
import { FaPlusCircle, FaCheck, FaTimes } from 'react-icons/fa'
import firebase from "../../firestore"
import Loading from '../Loading'

// Importing other components to main component
import Basic from './Basic'
import Skills from './Skills'
import Work from './Work'
import Education from './Education'
import Projects from './Projects'

class MainForm extends Component {
    state = {
        unique: false,
        key: 1,
        username: "",
        uid: '',
        // General Form
        name: '',
        tagline: '',
        about: '',
        email: firebase.auth().currentUser.email,
        phone: '',
        facebook: '',
        instagram: '',
        linkedin: '',
        twitter: '',
        github: '',
        resume: '',

        // Skill Set

        companyDetails: [],
        project: [],
        skills: [],
        education: {
            ssc: { instName: '', univ: '', yop: '', state: '' },
            hssc: { instName: '', univ: '', yop: '', state: '', stream: '' },
            grad: { instName: '', univ: '', yop: '', state: '', progname: '' }
        },
        loading: true,
        sending: false
    }

    oldUser = false
    usernameChanged = false
    originalUsername = ''
    componentDidMount() {
        firebase.database().ref('/users/').orderByChild('email').equalTo(firebase.auth().currentUser.email).once("value", (snapshot) => {
            if (snapshot.val() !== null) {
                const username = Object.keys(snapshot.val())[0]
                firebase.database().ref('/users/' + username).once('value', (snapshotC) => {
                    this.setState(snapshotC.val())
                    this.oldUser = true
                    this.originalUsername = snapshotC.val().username
                    this.setState({ unique: true })
                    this.setState({ loading: false })
                })
            }
            this.setState({ loading: false })
        });
    }

    changeHandler = obj => {
        this.setState(obj)
    }

    handleSelect(key) {
        this.setState({ key });
    }

    render() {
        if (this.state.loading) {
            // return (<Loading loaderState={this.state.loading} />)
            // return <h1 className="loadingHeading">Loading</h1>
            return <Loading />
        }

        return (
            <div className="FormsContainer">

                <div className="TabsContainer">
                    <div className="uniqueContainer">
                        <label>https://fresume.in/</label>&nbsp;
                        <input value={this.state.username} onChange={(e) => {
                            this.setState({
                                username: e.target.value
                            })
                            firebase.database().ref('/users').once('value', (snapshot) => {
                                if (this.state.username === this.originalUsername && this.oldUser) {
                                    this.setState({ unique: true })
                                    return
                                }
                                if (this.state.username === "") {
                                    this.setState({ unique: false })
                                    return
                                }
                                if (snapshot.hasChild(this.state.username)) {
                                    this.setState({ unique: false })
                                    return
                                }
                                this.setState({ unique: true })
                            })
                        }}
                            type="text" className={this.state.unique ? "uniqueInput green" : "uniqueInput red"} placeholder="Enter your unique username"
                        /> &nbsp;
                        <span>{!this.state.sending ? (this.state.unique ? <FaCheck style={{ color: "rgb(8, 201, 8)" }} /> : <FaTimes style={{ color: "rgb(201, 8, 8)" }} />) : null}</span>
                    </div>
                    <Tabs activeKey={this.state.key} id="uncontrolled-tab-example" >
                        <Tab eventKey={1} className="detailsTabEach" title="General" >
                            <Basic state={[this.state, this.changeHandler]} />
                            <div className="buttonContainerForms">
                                <Button className="continue" onClick={() => this.handleSelect(2)}>
                                    Continue
                                    </Button>
                            </div>
                        </Tab>
                        <Tab eventKey={2} title="Skill Set">
                            <Skills state={[this.state.skills, this.changeHandler]} />
                            <div className="buttonContainerForms">
                                <Button className="continue" onClick={() => this.handleSelect(1)}>
                                    Go Back
                                    </Button>  {' '}
                                <Button className="continue" onClick={() => this.handleSelect(3)}>
                                    Continue
                                    </Button>
                            </div>

                        </Tab>
                        <Tab eventKey={3} title="Work Experience">
                            <div>

                                {
                                    this.state.companyDetails.map((company, index) => {
                                        return (
                                            <Work
                                                key={company.id}
                                                state={[this.state.companyDetails, this.changeHandler, company.id]}
                                                deleteHandler={() => {
                                                    this.setState((currentState) => {
                                                        const newState = [...currentState.companyDetails]
                                                        newState.splice(index, 1)
                                                        return { companyDetails: newState }
                                                    })
                                                }}
                                            />
                                        )
                                    })
                                }
                                <Button
                                    onClick={() => {
                                        this.setState((currentState) => {
                                            const newState = [...currentState.companyDetails]
                                            const newid = newState.length
                                            newState.push({ id: newid, name: '', role: '', from: '', to: '' })
                                            return { companyDetails: newState }
                                        })
                                    }}
                                    variant="info" size="sm" className="addBTN"><span>Add Company</span>&nbsp;<FaPlusCircle /></Button>
                                <div className="buttonContainerForms">
                                    <Button className="continue" variant="primary" onClick={() => this.handleSelect(2)}>
                                        Go Back
                                    </Button> {' '}
                                    <Button className="continue" variant="primary" type="submit" onClick={() => this.handleSelect(4)}>
                                        Continue
                                    </Button>
                                </div>

                            </div>

                        </Tab>
                        <Tab eventKey={4} title="Education">
                            <Education
                                state={[this.state.education, this.changeHandler]} />
                            <div className="buttonContainerForms">
                                <Button className="continue" variant="primary" onClick={() => this.handleSelect(3)}>
                                    Go Back
                                    </Button> {' '}
                                <Button className="continue" variant="primary" type="submit" onClick={() => this.handleSelect(5)}>
                                    Continue
                                    </Button>
                            </div>
                        </Tab>
                        <Tab eventKey={5} title="Projects">

                            {
                                this.state.project.map((project, index) => {
                                    return (
                                        <Projects
                                            key={project.id}
                                            state={[this.state.project, this.changeHandler, project.id]}
                                            deleteHandler={() => {
                                                this.setState((currentState) => {
                                                    const newState = [...currentState.project]
                                                    newState.splice(index, 1)
                                                    return { project: newState }
                                                })
                                            }}
                                        />
                                    )
                                })
                            }
                            <Button
                                onClick={() => {
                                    this.setState((currentState) => {
                                        const newState = [...currentState.project]
                                        const newid = newState.length
                                        newState.push({ id: newid, name: '', link: '', desc: '' })
                                        return { project: newState }
                                    })
                                }}
                                variant="info" size="sm" className="addBTN"><span>Add Project</span>&nbsp;<FaPlusCircle /></Button>
                            <div className="buttonContainerForms">
                                <Button className="continue" variant="primary" onClick={() => this.handleSelect(4)}>
                                    Go Back
                                </Button>{' '}
                                <Button className="continue" onClick={async () => {
                                    this.setState({ sending: true, key: 5 })
                                    if (this.state.username === '') {
                                        alert('username username')
                                        this.setState({ sending: false })
                                        return
                                    }
                                    if (this.state.username !== this.originalUsername) {
                                        if (!this.state.unique) {
                                            alert('username not unique \'-_-\'')
                                            this.setState({ sending: false })
                                            return
                                        }

                                        await firebase.database().ref('/users/').once('value', (snapshot) => {
                                            if (snapshot.hasChild(this.state.username)) {
                                                // console.log("asa re");
                                                alert('username not unique \'-_-\'')
                                                this.setState({ sending: false })
                                                return
                                            }
                                        });
                                    }
                                    this.setState({ unique: true })

                                    const ref = firebase.database().ref('/users/')
                                    const temp = {}
                                    temp[this.state.username] = this.state
                                    delete temp[this.state.username].unique
                                    delete temp[this.state.username].loading
                                    delete temp[this.state.username].sending
                                    delete temp[this.state.username].key
                                    if (this.oldUser) {
                                        await ref.child(this.originalUsername).remove()
                                    }
                                    await ref.update(temp)
                                    window.location = '/dashboard'

                                }}
                                >
                                    {this.state.sending ?
                                        <React.Fragment>
                                            <Spinner
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                            />
                                            {' '}
                                        </React.Fragment>
                                        : null}

                                    Submit
                                </Button>
                            </div>


                        </Tab>
                    </Tabs>

                </div>
            </div>

        )
    }
}

export default MainForm;